import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CollapsibleSection = ({ title, children, defaultOpen = true }) => {
  return (
    <Accordion
      defaultExpanded={defaultOpen}
      sx={{
        mb: 2,
        borderRadius: "12px !important",
        boxShadow: 1,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          background: "#f7f9fc",
          borderRadius: "12px",
        }}
      >
        <Typography
          variant="h5"
          sx={{ color: "#0049aa", fontWeight: "600"}}
        >
          {title}
        </Typography>
      </AccordionSummary>

      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default CollapsibleSection;
